import { render, staticRenderFns } from "./InformacoesMaterial.vue?vue&type=template&id=94f8c7d4&scoped=true&"
import script from "./InformacoesMaterial.vue?vue&type=script&lang=js&"
export * from "./InformacoesMaterial.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesMaterial.vue?vue&type=style&index=0&id=94f8c7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f8c7d4",
  null
  
)

export default component.exports